export function useMsUrls() {
  const config = useRuntimeConfig();

  const availability = `${config.public.apiBaseUrl}/availability/api/v1`;
  const gfsSupplier = `${config.public.apiBaseUrl}/gfssupplier/api/v1`;
  const courrierWrapperBaseUrl = `${config.public.apiBaseUrl}/itcourrierwrapper/api/v1`;
  const floristInputBaseUrl = `${config.public.apiBaseUrl}/itflorist/api/v1/FloristInput`;
  const floristQueriesBaseUrl = `${config.public.apiBaseUrl}/itfloristqueries/api/v1/FloristQueries`;
  const keyCloakBaseUrl = `${config.public.keycloakUrl}/admin/realms/${config.public.keycloakRealm}`;
  const mailSender = `${config.public.apiBaseUrl}/emailsender/api/v1`;
  const notificationSupplierBaseUrl = `${config.public.apiBaseUrl}/notificationsupplier/api/v1/Notification`;
  const orderPost = `${config.public.apiBaseUrl}/itctorderwrapper/api/v1`;
  const orderWrapperBaseUrl = `${config.public.apiBaseUrl}/itctorderwrapper/api/v1`;
  const kpi = `${config.public.apiBaseUrl}/pfskpi/api/v1/Kpi`;
  const flashInfo = `${config.public.apiBaseUrl}/itflashinfo/api/v1`;
  const partnersurl = `${config.public.apiBaseUrl}/partnersurl`;
  const floristSettings = `${config.public.apiBaseUrlFlashInfo}/floristsettings/api/v1`;
  const pfsBackOffice = `${config.public.apiBaseUrl}/pfsbackoffice/api/v1`;
  const fileUploader = `${config.public.apiBaseUrl}/fileuploader/api/v1`;
  const smsServiceBaseUrl = `${config.public.apiBaseUrl}/itrecipientsms/api/v1`;
  const documents = `${config.public.apiBaseUrl}/itmsdocuments/api/v1`;
  const itmsdocuments = `${config.public.apiBaseUrl}/itmsdocuments/api/v1/`;

  return {
    availability,
    gfsSupplier,
    courrierWrapperBaseUrl,
    floristInputBaseUrl,
    floristQueriesBaseUrl,
    keyCloakBaseUrl,
    mailSender,
    notificationSupplierBaseUrl,
    orderPost,
    orderWrapperBaseUrl,
    kpi,
    flashInfo,
    partnersurl,
    floristSettings,
    pfsBackOffice,
    fileUploader,
    smsServiceBaseUrl,
    documents,
    itmsdocuments,
  };
}
